module.exports = {
	"firstName": "olivia",
	"name": "olivia by nature",
	"shortname": "olivia-by-nature",
	"website_handle": "oliviabynature.com",
	"website_url": "https://oliviabynature.wordpress.com/",
	"instagram_handle": "oliviabynature",
	"instagram_url": "https://www.instagram.com/oliviabynature/?hl=en",
	"description": "London-based blogger Olivia is the epitome of retro, portraying a cool style with bohemian vibes. A strong supporter of ethical consumerism, she adapts her style to balance trends and earth-caring behaviour giving her fashion sense a unique twist.",
	"interview": [
		{
			"title": "1. What does this collection say about yourself?",
			"description": "I like to dress a little differently, wear something that’s a little quirky, and this collection just takes a small bit of this ‘difference’ and tames it down so that everyone can enjoy a little piece :)"
		},
		{
			"title": "2. What does creativity mean for you?",
			"description": "That’s easy, it means being yourself, the best way to be creative is to dress exactly how you want to, do exactly want you want to do, stay true to yourself and come into your being. Creativity to me is allowing myself to dress quirky and colourfully, because that’s who I am, and not allowing anybody to tell me how I should dress or behave. Creativity is a personal thing, anyone can be creative as long as you let yourself come alive, and stop following what is socially perceived as the societal norms."
		},
		{
			"title": "3. Winter styles or summer fashion?",
			"description": "This is a tough one because I am an absolute sucker for a good coat/jacket! But I guess I would have to say summer, because it allows you more freedom and choice with what you can wear :)"
		}
	],
	"quote": "I have loved discovering the creativity and artistic insight that goes into designing clothing",
	"media": [
		"/media/img/influencers/olivia/olivia_slider-2.jpg",
		"/media/img/influencers/olivia/olivia_slider-3.jpg",
		"/media/img/influencers/olivia/olivia_slider-4.jpg",
		"/media/img/influencers/olivia/olivia-by-nature_hero.jpg"
	],
	"socialItems": [
		{
			"url": "https://www.instagram.com/p/BI91bIoBtIt/",
			"img": "https://scontent-ams3-1.cdninstagram.com/t51.2885-15/e35/13714262_636449716511184_1914867691_n.jpg?ig_cache_key=MTMxNDQ0MTYyNzQxNDQ4MzUwMQ%3D%3D.2",
			"likes": 1984
		},
		{
			"url": "https://www.instagram.com/p/BI-c8sqBVR-/",
			"img": "https://scontent-ams3-1.cdninstagram.com/t51.2885-15/sh0.08/e35/p750x750/13768210_516686575206136_1004609477_n.jpg?ig_cache_key=MTMxNDYxNTQ1NzY1OTMxMTIzMA%3D%3D.2",
			"likes": 2255
		},
		{
			"url": "https://www.instagram.com/p/BJctOcsBsfz/",
			"img": "https://scontent-ams3-1.cdninstagram.com/t51.2885-15/e35/14052301_1152265628170960_1381843141_n.jpg?ig_cache_key=MTMyMzEzMTI5NTUwOTE3MDE2Mw%3D%3D.2",
			"likes": 2926
		},
		{
			"url": "https://www.instagram.com/p/BMHNLuiji11/",
			"img": "https://scontent-ams3-1.cdninstagram.com/t51.2885-15/e35/14659311_1221134471281060_3109184549934858240_n.jpg?ig_cache_key=MTM3MTEyMjU5MjA0ODM2MDgyMQ%3D%3D.2",
			"likes": 3112
		},
		{
			"url": "https://www.instagram.com/p/BMRt6ZpDD03/",
			"img": "https://scontent-ams3-1.cdninstagram.com/t51.2885-15/e35/14592161_1779331955648928_4809040276779696128_n.jpg?ig_cache_key=MTM3NDA4MTI4NjY3OTU3NTg2Mw%3D%3D.2",
			"likes": 2398
		},
		{
			"url": "https://www.instagram.com/p/BNZ1l1pj1ks/",
			"img": "https://scontent-ams3-1.cdninstagram.com/t51.2885-15/e35/15259011_1508556279160467_5906483564270059520_n.jpg?ig_cache_key=MTM5NDM4MTI1NjMzOTE4MzkxNg%3D%3D.2",
			"likes": 1699
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./data/influencers/olivia-by-nature.json
// module id = 78
// module chunks = 0